import {makeAutoObservable, runInAction} from "mobx";
import {VISIBLE_TIME_OUT} from "@/components/constants";
import {getStore, useStore} from "./index.jsx";

/**
 * @typedef {object} ConfirmContent
 * @property {string} title
 * @property {string} text
 * @property {Function|null} confirmFunc
 * @property {Function|null} cancelFunc
 * @property {Function|null} closeFunc
 * @property {string} confirmText
 * @property {string|null} cancelText
 * @property {string|null} textColor
 */


/**
 * 공통 Confirm 상태 관리 Store
 */
export class ConfirmStore {
    /**
     * Confirm 노출 여부
     * @type {boolean}
     */
    visible = false;

    /**
     * Confirm 컨텐츠 데이터
     * @type {ConfirmContent}
     */
    content = {
        title: "",
        text: "",
        cancelFunc: null,
        closeFunc: null,
        cancelText: "취소",
        confirmFunc: null,
        confirmText: "",
        textColor: null,
    };

    constructor(store) {
        this.store = store;
        makeAutoObservable(this, {}, {autoBind: true});
    }

    /**
     * Confirm 오픈 및 데이터 세팅 함수
     *
     * @param {Object} config Confirm 설정 객체
     */
    openConfirm(config) {
        this.content = {
            text: config.text,
            confirmFunc: config.confirmFunc,
            cancelFunc: config.cancelFunc || null,
            closeFunc: config.closeFunc || null,
            confirmText: config.confirmText,
            cancelText: config.cancelText || null,
            textColor: config.textColor || null,
            title: config.title,
        }
        this.visible = true;
    }

    /**
     * Confirm 상태 및 데이터 초기화 함수
     * 닫기 애니메이션 이후 content 데이터 초기화
     */
    clear() {
        this.visible = false;
        setTimeout(() => {
            runInAction(() => {
                this.content = {
                    title: "",
                    text: "",
                    cancelFunc: null,
                    closeFunc: null,
                    cancelText: "취소",
                    confirmFunc: null,
                    confirmText: "",
                    textColor: null,
                };
            });
        }, VISIBLE_TIME_OUT);
    }
}

/**
 * ConfirmStore Hook
 *
 * @returns {ConfirmStore}
 */
export const useConfirmStore = () => {
    return useStore().confirmStore;
}

/**
 * ConfirmStore 직접 접근 함수
 *
 * @returns {ConfirmStore}
 */
export const getConfirmStore = () => {
    return getStore().confirmStore;
}
